var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"t-progress"},[_c('div',{class:!_vm.indeterminate ? 't-progress-bar' : 't-indeterminate',style:(_vm.barStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }